import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const getActiveSessions = (
  username: string | null,
  token: string | null
): Promise<AxiosResponse> => {
  const params: any = {};
  const headers: any = {};
  username?.length && (params["username"] = username);
  if (token?.length) {
    headers["Authorization"] = token;
  }
  const config: AxiosRequestConfig = {
    params,
    headers,
  };
  return axiosAuth.get(API_PATH().apis.sessions, config);
};

export const updateSession = (
  updateSessionObject: any,
  token: string | null
): Promise<AxiosResponse> => {
  const headers: any = {};
  if (token?.length) {
    headers["Authorization"] = token;
  }
  const config: AxiosRequestConfig = {
    headers,
  };
  return axiosAuth.put(API_PATH().apis.session, updateSessionObject, config);
};
